export enum Role {
  ADMIN = 'admin',
  USER = 'user',
  INTERNAL = 'internal',
  CUSTOMER = 'customer',
  ROBVISION_CUSTOMER = 'robvision-customer',
  CUSTOMER_DEVAUGE_TANGERMUNDE = 'customer-devauge-tangermunde',
  CUSTOMER_DEVAUGE_LUNEBURG = 'customer-devauge-luneburg',
  SOLUTIONS = 'solutions',
  TECH = 'tech',
  PROVISIONING_UNIT = 'provisioning-unit',
  CONCEPT_ENGINEERING = 'concept_engineering',
  SALES = 'sales',
  SOLUTIONS_POWERUSER = 'solutions_poweruser',
}

export enum GroupRole {
  ADMIN = 'admin',
  VIEWER = 'viewer',
}

export interface PermissionsResponse {
  permissions: Permission[];
  role: string;
}

export enum Permission {
  GET_CLOUD_ROBFLOW = 'get:cloud-robflow',
  GET_CONTROL_UNIT = 'get:control-unit',
  GET_CONTROL_UNIT_PASSWORD = 'get:control-unit-password',
  POST_CONTROL_UNIT = 'post:control-unit',
  PATCH_CONTROL_UNIT = 'patch:control-unit',
  DELETE_CONTROL_UNIT = 'delete:control-unit',
  GET_USER = 'get:user',
  PATCH_USER = 'patch:user',
  GET_GRAFANA = 'get:grafana',
  GET_ROBFLOW = 'get:robflow',
  GET_ROLES = 'get:roles',
  GET_CALCULATOR = 'get:calculator',
  GET_DEVAUGE_TANGERMUNDE_VARIABLES = 'get:devauge-tangermunde-variables',
  GET_DEVAUGE_LUNEBURG_VARIABLES = 'get:devauge-luneburg-variables',
  GET_CATALOGUE = 'get:catalogue',
  UPDATE_CATALOGUE = 'update:catalogue',
  UPDATE_CATALOGUE_ALL = 'update:catalogue:all',
  GET_ROBVISION = 'get:robvision',
  GET_OEE_METRICS = 'get:oee-metrics',
  GET_NPS = 'get:nps',
  INTERNAL_ACCESS = 'internal-access',
  GET_EDGE_DEVICE = 'get:edge-device',
  POST_EDGE_DEVICE = 'post:edge-device',
  PATCH_EDGE_DEVICE = 'patch:edge-device',
  DELETE_EDGE_DEVICE = 'delete:edge-device',
  GET_CUSTOMER = 'get:customer',
  POST_CUSTOMER = 'post:customer',
  PATCH_CUSTOMER = 'patch:customer',
  DELETE_CUSTOMER = 'delete:customer',
}
